import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DataService } from '../../../data.service';

@Component({
  selector: 'app-preview-or-print',
  templateUrl: './preview-or-print.component.html',
  styleUrls: ['./preview-or-print.component.scss']
})
export class PreviewOrPrintComponent implements OnInit {

  @Input() item: any;
  @Input() print: boolean = false;
  // @Output() print: EventEmitter<boolean> = new EventEmitter();

  constructor(public dataService: DataService) { }

  ngOnInit() {
    
  }

  imageLoaded() {
    if( !!this.print ) {
      window.print();
      // this.print.emit(false);
    };
  }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/asset-library/preview-or-print/preview-or-print.component.ts